import React, { Component } from "react"
import { connect, getIn } from "formik"
import Checkbox from "react-toolbox/lib/checkbox"
import _ from "lodash"

class FormikCheckbox extends Component {
  props: {
    formik: any,
    name: string,
  }

  handleChange = ( formik, name ) => newValue => {
    formik.setFieldValue( name, newValue )
  }

  render () {
    const inputProps = _.omit( this.props, [ "formik" ] )

    const { name, formik } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    return (
      <Checkbox
        {...inputProps}
        checked={value}
        error={touched && error ? error : undefined}
        onChange={this.handleChange( formik, name )}
        onBlur={formik.handleBlur( name )}
      />
    )
  }
}

export default connect( FormikCheckbox )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/Checkbox.jsx